import { render, staticRenderFns } from "./AddMetodocalculoPage.vue?vue&type=template&id=98c6707e"
import script from "./AddMetodocalculoPage.vue?vue&type=script&lang=js"
export * from "./AddMetodocalculoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports